import apiCall from "../../utils/apiCall";
import {apiUrls} from "../../constants/apiUrls";
import {CreateContainerPlatform, UpdateContainerPlatform} from "../../types/api/guide/containerPlatform.types";

const pagedQuery = (page: number, pageSize: number, name?: string) => {
    const params: Record<string, string | number> = { page, pageSize };
    if (name != null && name.trim() !== "") params.name = name.trim();
    return { params };
};

export const containerPlatformService = {
    getAll: () =>
        apiCall.get(apiUrls.guide.containerPlatforms.getAll),

    getPaged: (page: number, pageSize: number, name?: string) =>
        apiCall.get(apiUrls.guide.containerPlatforms.getPaged, pagedQuery(page, pageSize, name)),

    getById: (id:string) =>
        apiCall.get(apiUrls.guide.containerPlatforms.getById(id)),

    create: (containerPlatforms: CreateContainerPlatform) =>
        apiCall.post(apiUrls.guide.containerPlatforms.create, containerPlatforms),

    update: (id: string, containerPlatforms: UpdateContainerPlatform) =>
        apiCall.put(apiUrls.guide.containerPlatforms.update(id), containerPlatforms),

    delete: (id: string) =>
        apiCall.delete(apiUrls.guide.containerPlatforms.delete(id)),
}